export const onOpenMessenger = (username: string) => () => {
  window.open(`https://m.me/${username}`, 'chat', 'width=800,height=600');
};
